import { Logger } from '~/plugins/log'
const logger = new Logger()
logger.setContext('Banner')

const getDefaultState = () => ({
  banners: [],
  lastUpdate: null
})

export const state = getDefaultState

export const mutations = {
  SET_BANNERS (state, banners) {
    state.banners = banners
    state.lastUpdate = (new Date()).valueOf()
  },
  RESET (state) {
    Object.assign(state, getDefaultState())
  }
}

export const getters = {
  banners: state => state.banners
}

export const actions = {
  async GET ({ commit, rootGetters }) {
    try {
      const { data } = await this.$publicAPI.get(`banners/fetch/?season=${rootGetters['store/season']}`, { useCache: true })
      commit('SET_BANNERS', data.banners)
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  },
  async GET_PREVIEW ({ commit }, id) {
    try {
      const { data } = await this.$publicAPI.get(`banners/${id}/`)
      return data
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
      return false
    }
  },
  async VIEW (_, { banner, position }) {
    if (!banner) return
    try {
      await this.$publicAPI.quietPost(`banners/${banner.id}/view/?pos=${position}`)
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  },
  async CLICK (_, { banner, position }) {
    if (!banner) return
    try {
      await this.$publicAPI.quietPost(`banners/${banner.id}/click/?pos=${position}`)
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  },
  async SKIP (_, { banner, position }) {
    if (!banner) return
    try {
      await this.$publicAPI.quietPost(`banners/${banner.id}/skip/?pos=${position}`)
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  }
}
